namespace Matrix.Exceptions {
    export interface ExceptionPolicyIgnoreForm {
        IgnorePolicyCode: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class ExceptionPolicyIgnoreForm extends Serenity.PrefixedContext {
        static formKey = 'Exceptions.ExceptionPolicyIgnore';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ExceptionPolicyIgnoreForm.init)  {
                ExceptionPolicyIgnoreForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = StaticTextBlock;
                var w2 = ReadOnlyDateTime;

                Q.initFormType(ExceptionPolicyIgnoreForm, [
                    'IgnorePolicyCode', w0,
                    'Description', w0,
                    'Version', w1,
                    'CreatedBy', w1,
                    'CreatedWhen', w2,
                    'UpdatedBy', w1,
                    'UpdatedWhen', w2
                ]);
            }
        }
    }
}
